import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const KycDocumentApi = createApi({
  reducerPath: "KycDocumentApi",
  baseQuery,
  tagTypes: ["KycDocument"],

  endpoints: (builder) => ({
    getKycDocument: builder.query({
      query: ({ id }) => `customers/kycDocument/${id}`,
    
      transformResponse: (response) => {
        console.log("KYC Document API response =", response);
        return response?.data ?? {};
      },
    
      providesTags: ["KycDocument"],
    }),
    createKycDocument: builder.mutation({
      query: ({ id, ...data }) => ({
        url:`customers/kycDocument/${id}`, 
        method: "PUT",
        headers: { 
          "X-Request-Id": Math.random().toString(36).substring(2)
        },
        body: data,
      }),
      invalidatesTags: ["KycDocument"],
    }),
 
  }),
});

export const {
  useLazyGetKycDocumentQuery,
  useCreateKycDocumentMutation
} = KycDocumentApi;
